import { mapActions } from 'vuex'

export default {
  methods: {
    ...mapActions('itemstateModule', ['syncStoreTempState'])
  }
}
